<app-view-item *ngIf="readonly && selected" [text]="getProjectLabel(selected)" [borderless]="borderless"></app-view-item>
<app-view-item *ngIf="readonly && !selected" [text]="''" [borderless]="borderless"></app-view-item>

<nz-select *ngIf="!readonly"
  #selector
  nzShowSearch
  nzServerSearch
  [nzAllowClear]="true"
  [nzBackdrop]="addBackdrop"
  [nzFilterOption]="nzFilterOption"
  (nzOnSearch)="search($event, 20)"
  (nzOpenChange)="search('')"
  (nzScrollToBottom)="loadMore()"
  (keydown)="handleKeyDown($event)"
  (click)="handleClick($event)"
  [nzCustomTemplate]="displayTpl"
  [(ngModel)]="value"
  (ngModelChange)="valueChanged($event)"
  [nzDropdownMatchSelectWidth]="false"
  [nzBorderless]="borderless"
  class="width-100"
  [nzMode]="mode"
>
  <ng-template #displayTpl let-selected>
    {{ selected.nzLabel }}
  </ng-template>
  
  <!-- <ng-container *ngFor="let o of list">
    <nz-option *ngIf="!searching" [nzValue]="getValue(o)" [nzLabel]="selected ? selected.code : ''" nzCustomContent>
      <div class="dropdown-container">
        <strong>{{ o.code }}</strong>
        :
        <span> {{ o.name }}</span>
      </div>
    </nz-option>
  </ng-container> -->
  <ng-container *ngFor="let o of list">
    <nz-option
      *ngIf="!searching"
      [nzValue]="getValue(o)"
      [nzLabel]="getProjectLabel(o)"
      nzCustomContent
    >
      <span>{{ o.code }}</span>
      :
      <span> {{ o.name }}</span>
    </nz-option>
  </ng-container>
</nz-select>
